import {
  GET_CONTACTS_REQUEST,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_FAILURE,
  statusType
} from '../../actions'

const initial = {
  data: [],
  total: 0,
  meta: {
    total: 0,
    maxTotal: 0
  },
  status: statusType.IDLE,
  initialLoading: true
}

const contacts = (state = initial, action) => {
  const { payload, meta } = action

  switch (action.type) {
    case GET_CONTACTS_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACTS_SUCCESS:
      return {
        ...state,
        ...meta,
        data: payload,
        initialLoading: false,
        status: statusType.SUCCESS
      }

    case GET_CONTACTS_FAILURE:
      return {
        ...state,
        initialLoading: false,
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default contacts
